import { Utilidades } from "./Utilidades";

export abstract class Constantes {
    private static readonly _ERROR_CARGAR_DATOS: string = "Error al cargar datos";
    private static readonly _DATOS_GRABADOS: string = "Datos insertados con éxito!!!";
    private static readonly _ERROR_GRABAR_DATOS: string = "Error al insertar datos!";
    private static readonly _DATOS_EXCLUIDOS: string = "Datos excluídos con éxito!!!";
    private static readonly _ERROR_EXCLUIR_DATOS: string = "Error al excluir!";
    private static readonly _ACTUALIZAR_DATOS: string = "Datos actualizados con éxito!!!";
    private static readonly _ERROR_ACTUALIZAR_DATOS: string = "Error al actualizar datos";
    private static readonly _SIN_DATOS: string = "Sin datos";
    private static readonly _CAMPOS_OBLIGATORIOS: string = "* Campos Obligatórios";
    private static readonly _CAMPO_OBLIGATORIO: string = "Campo Obligatório";
    // private static readonly _VERSION: string = "v 0.0.0.86";

    // public static get VERSION(): string {
    //     return this._VERSION;
    // }

    public static get EN_DESARROLLO(): string {
        return Utilidades.traduccion({ texto: "En desarrollo!!", tag: "EN_DESARROLLO" });
    }

    public static get USUARIO_ACTIVADO(): string {
        //return Utilidades.traduccion({ texto: "Usuário activado con éxito.", tag: "USUARIO_ACTIVADO_CON_EXITO" });
        return "Su usuario ha sido activado con éxito. Ya puede acceder a su cuenta con su usuario y contraseña!"
    }

    public static get ERROR_CARGAR_DATOS(): string {
        return Utilidades.traduccion({ texto: "Error al cargar datos", tag: "ERROR_AL_CARGAR_DATOS" });
    }

    public static get DATOS_GRABADOS(): string {
        return Utilidades.traduccion({ texto: "Datos insertados con éxito", tag: "DATOS_INSERTADOS_CON_EXITO" });
    }

    public static get EMAIL_ENVIADO(): string {
        return Utilidades.traduccion({ texto: "Email enviado con éxito", tag: "EMAIL_ENVIADO_CON_EXITO" });
    }

    public static get ENVIAR_FACTURA_HACIENDA(): string {
        return Utilidades.traduccion({ texto: "Factura enviada a Hacienda con éxito", tag: "ENVIAR_FACTURA_HACIENDA_CON_EXITO" });
    }

    public static get ERROR_FACTURA_ENVIDADA_HACIENDA(): string {
        return Utilidades.traduccion({ texto: "Error al enviar factura hacia Hacienda", tag: "ERROR_ENVIAR_FACTURA" });
    }

    public static get ERROR_AL_EMAIL_ENVIADO(): string {
        return Utilidades.traduccion({ texto: "Error al email enviado", tag: "ERROR_AL_EMAIL_ENVIADO" });
    }

    public static get ERROR_AL_CARGAR_FICHERO(): string {
        return Utilidades.traduccion({ texto: "Error al cargar fichero", tag: "ERROR_AL_CARGAR_FICHERO" });
    }

    public static get ERROR_GRABAR_DATOS(): string {
        return Utilidades.traduccion({ texto: "Error al insertar datos", tag: "ERROR_AL_INSERTAR_DATOS" });
    }

    public static get DATOS_EXCLUIDOS(): string {
        return Utilidades.traduccion({ texto: "Datos excluídos con éxito", tag: "DATOS_EXCLUIDOS_CON_EXITO" }) + "!!!";
    }

    public static get ERROR_EXCLUIR_DATOS(): string {
        return Utilidades.traduccion({ texto: "Error al excluir", tag: "ERROR_AL_EXCLUIR" });
    }

    public static get ACTUALIZAR_DATOS(): string {
        return Utilidades.traduccion({ texto: "Datos actualizados con éxito", tag: "DATOS_ACTUALIZADOS_CON_EXITO" }) + "!!!";
    }

    public static get ERROR_ACTUALIZAR_DATOS(): string {
        return Utilidades.traduccion({ texto: "Error al actualizar datos", tag: "ERROR_AL_ACTUALIZAR_DATOS" });
    }

    public static get ERROR_PERMISOS_NECESARIOS(): string {
        return Utilidades.traduccion({ texto: "Su perfil no tiene los permisos necesarios.", tag: "PERFIL_NO_TIENE_PERMISOS_NECESARIOS" });
    }

    public static get SIN_DATOS(): string {
        return Utilidades.traduccion({ texto: "Sin datos", tag: "SIN_DATOS" });
    }

    public static get ERROR_DESCARGAR_FICHERO(): string {
        return Utilidades.traduccion({ texto: "Error al descargar fichero", tag: "ERROR_DESCARGAR_FICHERO" });
    }

    public static get FICHERO_DESCARGADO(): string {
        return Utilidades.traduccion({ texto: "Fichero descargado con éxito", tag: "FICHERO_DESCARGADO" });
    }

    public static get CAMPOS_OBLIGATORIOS(): string {
        return "* " + Utilidades.traduccion({ texto: "Campos Obligatórios", tag: "CAMPOS_OBLIGATORIOS" });
    };

    public static get CAMPO_OBLIGATORIO(): string {
        return Utilidades.traduccion({ texto: "Campo Obligatório", tag: "CAMPO_OBLIGATORIO" });
    };

    public static get NO_SE_HA_INFORMADO_TODOS_LOS_CAMPOS(): string {
        return Utilidades.traduccion({ texto: "No se ha informado todos los campos obligatórios", tag: "NO_SE_HA_INFORMADO_TODOS_LOS_CAMPOS_OBLIGATORIOS" });
    };

    public static get NO_SE_HA_INFORMADO_TODOS_LOS_CAMPOS_CREAR_FACTURA(): string {
        return Utilidades.traduccion({ texto: "No se ha informado todos los campos obligatórios para crear la factura", tag: "NO_SE_HA_INFORMADO_TODOS_LOS_CAMPOS_OBLIGATORIOS_PARA_CREAR_LA_FACTURA" });
    };

    public static readonly ERROR_LOGIN: string = "Error al intentar hacer el login!";
    public static readonly URL_BASE_API: string = "https://facturapi.apperos.com/api";
    public static readonly RUTA_COMBO: string = "/admin/v1";
    public static readonly RUTA_TRADUCCION: string = "/admin/traduccion";
    public static readonly SESSION_COOKIE: string = "facturapp_session";

    public static readonly dateTimeFormats = {
        'en-GB': {
            short: {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            },
            long: {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                weekday: 'long',
                hour: 'numeric',
                minute: 'numeric'
            },
            time: {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true
            }
        },
        'es-ES': {
            short: {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            },
            long: {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                weekday: 'long',
                hour: 'numeric',
                minute: 'numeric',
                hour12: false
            },            
            time: {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            }
        },
        'pt-BR': {
            short: {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            },
            long: {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                weekday: 'long',
                hour: 'numeric',
                minute: 'numeric',
                hour12: false
            },            
            time: {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            }
        }
    }

    public static readonly numberFormats = {
        'en-GB': {
            currency: {
                style: 'currency',
                currency: 'GBP',
            },
            decimal: {
                style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
            },
            percent: {
                style: 'percent', useGrouping: false, maximumFractionDigits: 2
            }
        },
        'es-ES': {
            currency: {
                style: 'currency',
                currency: 'EUR',
                useGrouping: true,                
            },
            decimal: {
                style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
            },
            percent: {
                style: 'percent', useGrouping: false, maximumFractionDigits: 2
            }
        },
        'pt-BR': {
            currency: {
                style: 'currency',
                currency: 'BRL'
            },
            decimal: {
                style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
            },
            percent: {
                style: 'percent', useGrouping: false, maximumFractionDigits: 2
            }
        }
    }
}